<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a
    #rla="routerLinkActive"
    mat-tab-link
    routerLinkActive
    [routerLink]="['./', 'settings']"
    [active]="rla.isActive"
  >
    Settings
  </a>
  <a
    #rla2="routerLinkActive"
    mat-tab-link
    routerLinkActive
    [routerLink]="['./', 'webhooks']"
    [active]="rla2.isActive"
  >
    Webhooks
  </a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <div class="pt-8">
    <router-outlet />
  </div>
</mat-tab-nav-panel>
